export default __webpack_public_path__ + "static/media/closeTable.bc33f38a.svg";